import { t } from "i18n-js";
import basicRequest, { GET_REQUEST, POST_REQUEST, DELETE_REQUEST } from "../../../../core/redux/actions/request";

import { notification } from "antd";

const onSuccess = (message) => (dispatch) => {
    notification.success(message);
    dispatch(secondarySuccess(true));
};

const PREFIX = "MANAGER_VENDOR_SHOW";
const getState = (state) => state.manager.vendor.show;

const {
    requestPattern,

    actionPostPattern,
    actionPutPattern,

    error,
    loading,
    success,
    reset,
    getPattern,
    secondaryError,
    secondaryLoading,
    secondarySuccess,
    isSecondaryLoading,
    isLoaded,
    isLoading,
    getError,
    getData,
} = basicRequest(PREFIX, getState);

const customSuccess = (data) => {
    // se podria poner una notificacion
    return success(data);
};

export const updatePriority = (id, form) => actionPostPattern("manager/vendors/v2/" + id + "/priority", form);

export const postVendorTimelineMessage = (vendorId, form) =>
    actionPostPattern("manager/vendors/v2/" + vendorId + "/timeline", form);

export const postVendorBitacoraMessage = (vendorId, form) =>
    actionPostPattern("manager/vendors/v2/" + vendorId + "/bitacora", form);

export const createEventNotAvailable = (vendorId, form) =>
    actionPostPattern("manager/vendors/v2/" + vendorId + "/events/form", form);

export const dismissEvent = (vendorId, eventId) =>
    actionPutPattern("manager/vendors/v2/" + vendorId + "/dismiss-event/" + eventId, {});

export const validatePrices = (vendorId) =>
    actionPutPattern(
        "manager/vendors/v2/" + vendorId + "/validate-prices",
        {},
        onSuccess({
            message: "Update",
            description: "The price review was approved",
        })
    );
export const rejectPrices = (vendorId) =>
    actionPutPattern(
        "manager/vendors/v2/" + vendorId + "/reject-prices",
        {},
        onSuccess({
            message: "Update",
            description: "The price review was rejected",
        })
    );

export const load = (id) => getPattern("manager/vendors/v2/" + id, {}, null);

export const retrive = (id) => {
    const url = "manager/vendors/v2/" + id;

    return getPattern(url, {});
};

export const updatePaymentMethod = (id, form) =>
    requestPattern(
        "manager/vendors/v2/" + id + "/payment-method",
        POST_REQUEST,
        form,
        secondaryError,
        secondaryLoading,
        customSuccess
    );
export const deletePaymentMethod = (id, paymentId) =>
    requestPattern(
        "manager/vendors/v2/" + id + "/payment-method/" + paymentId,
        DELETE_REQUEST,
        {},
        secondaryError,
        secondaryLoading,
        customSuccess
    );

export const validatePaymentMethod = (vendorId) =>
    actionPutPattern(
        "manager/vendors/v2/" + vendorId + "/validate-payment-method",
        {},
        onSuccess({
            message: "Update",
            description: "The payment method review was approved",
        })
    );
export const rejectPaymentMethod = (vendorId) =>
    actionPutPattern(
        "manager/vendors/v2/" + vendorId + "/reject-payment-method",
        {},
        onSuccess({
            message: "Update",
            description: "The payment method review was rejected",
        })
    );

export const createStorageFolder = (id) =>
    actionPostPattern(
        `manager/vendors/v2/${id}/storage`,
        {},
        {
            message: "Created",
            description: "The folder was created",
        }
    );

export { reset, isLoading, getError, getData, isLoaded, isSecondaryLoading };
